import type { StateCreator } from "zustand";
import type { Middlewares, Mutators } from "./index";
import type { BuilderUIState, DragAndDropState } from "./types";

export const createDragAndDropSlice: StateCreator<
  BuilderUIState,
  Middlewares,
  Mutators,
  DragAndDropState
> = set => ({
  draggingTemplate: null,

  setDraggingTemplate: template =>
    set(
      { draggingTemplate: template },
      undefined,
      "dragAndDrop/setDraggingTemplate",
    ),
});
